import { Tag, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const fmtPromoDate = (d, lang = 'fr') => (d ? new Date(d).toLocaleDateString(lang === 'fr' ? 'fr-FR' : undefined, { day: 'numeric', month: 'long' }) : '');

// Badge « PROMO -20 % » (coin de la carte / fiche)
export const PromoBadge = ({ product, className = '' }) => {
  if (!product?.promo) return null;
  return (
    <div className={`bg-red-600 text-white text-[10px] px-2 py-0.5 uppercase tracking-wider font-semibold inline-flex items-center gap-1 ${className}`}
      data-testid={`promo-badge-${product.id}`}>
      <Tag className="w-3 h-3" /> Promo{product.promo.percent ? ` -${product.promo.percent}%` : ''}
    </div>
  );
};

// Ligne « Jusqu'au 20 octobre » + ancien prix barré
export const PromoInfo = ({ product, showOld = true, className = '' }) => {
  const { t, lang } = useLanguage();
  if (!product?.promo) return null;
  return (
    <div className={`flex flex-wrap items-center gap-x-2 text-xs ${className}`} data-testid={`promo-info-${product.id}`}>
      {showOld && product.price_detail_original && (
        <span className="text-muted line-through" data-testid={`promo-old-price-${product.id}`}>{product.price_detail_original}€</span>
      )}
      <span className="text-red-400 inline-flex items-center gap-1">
        <Clock className="w-3 h-3" /> {t('promo_until', { date: fmtPromoDate(product.promo.ends_at, lang) })}
      </span>
    </div>
  );
};
